import React from 'react'
import Icon from '../icon'
import { ButtonIcon, Container, ContainerIcon, Link } from './styles'

type Props = {
  urls: BreadCrumbsProps[]
}
/**
 *
 * @deprecated This will be removed in the future. Use Breadcrumbs instead.
 */

const Breadcrumbs: React.FC<Props> = (props: Props) => {
  return (
    <>
      <Container>
        <ol>
          {props.urls.map((breadcrumb, index) => {
            return (
              <>
                <li key={index}>
                  {breadcrumb.icon && (
                    <ButtonIcon href={breadcrumb.url}>
                      <Icon
                        name={breadcrumb.icon}
                        size={'20'}
                        color={'neutralColorLowLight'}
                      />
                    </ButtonIcon>
                  )}

                  <Link href={breadcrumb.url}>{breadcrumb.text}</Link>

                  {props.urls[index + 1] && (
                    <>
                      {breadcrumb.divider ? (
                        <>{breadcrumb.divider}</>
                      ) : (
                        <ContainerIcon>
                          <Icon
                            name="arrow_forward"
                            colors={'neutralColorLowLight'}
                            size={'10'}
                          />
                        </ContainerIcon>
                      )}
                    </>
                  )}
                </li>
              </>
            )
          })}
        </ol>
      </Container>
    </>
  )
}

Breadcrumbs.defaultProps = {
  urls: [
    { icon: 'home_outlined', text: '', url: 'Url' },
    { icon: null, text: <span>Link</span>, url: 'Url' },
  ],
}

export default Breadcrumbs

export interface BreadCrumbsProps {
  icon?: string
  text?: string | JSX.Element
  url?: string
  divider?: JSX.Element
}
